import React, { forwardRef } from 'react';
import PrdcUnitItem from '@wconcept/wconcept-ui-renewal/src/components/molecules/_item/PrdcUnitItem';
import { getExclusiveEmblemProp } from '@utils/productExclusiveUtil';
import { ObservedItem } from '@wconcept/wconcept-ui-renewal/src/components/organisms/_list/ProductList';
import { ProductObserveGridItemProps } from '../types';

const ProductObserveGridItem = forwardRef<
  HTMLDivElement,
  ProductObserveGridItemProps
>(
  (
    {
      product,
      originalIndex,
      isMobile,
      isLogin,
      myHeartList,
      showExclusiveEmblem,
      mobileVirtualColumnCount = 2,
      onClickProduct,
      onClickHeart,
      shouldObserve,
      index,
      setActiveVideoIndex,
      activeVideoIndex,
      visibleIndices,
      viewportOffset = { top: 0, bottom: 0 },
      isVideoPlay = true,
      onClickViewStylVd,
    },
    ref
  ) => (
    <ObservedItem
      key={`item-${originalIndex}`}
      shouldObserve={shouldObserve}
      index={originalIndex}
      setActiveVideoIndex={setActiveVideoIndex}
      activeVideoIndex={activeVideoIndex}
      visibleIndices={visibleIndices}
      viewportOffset={viewportOffset}
      isVideoPlay={isVideoPlay}
    >
      <PrdcUnitItem
        key={product.itemCd}
        vid={product.shortFormInfo?.vodInfo?.id}
        // videoSrc={product.shortFormInfo?.vodInfo?.playBackUrl}
        token={{
          playAuthToken: product.shortFormInfo?.vodInfo?.token as string,
        }}
        viewStylVdUrl={product.shortFormInfo?.landingUrl}
        isDesktop={!isMobile}
        isLogin={isLogin}
        priority
        ref={ref}
        itemCd={product.itemCd}
        statusCd={product.statusCd}
        finalPrice={product.finalPrice}
        customerPrice={
          mobileVirtualColumnCount === 3 ? undefined : product.customerPrice
        }
        finalDiscountRate={product.finalDiscountRate}
        reviewScore={product.reviewScore}
        reviewCnt={product.reviewCnt}
        hideHeartCnt={mobileVirtualColumnCount === 3}
        heartCnt={mobileVirtualColumnCount === 3 ? undefined : product.heartCnt}
        reserveTag={product.reserveTag}
        saleTag={product.saleTag}
        infoTags={product.infoTags}
        imageUrl={product.imageUrlMobile || product.productImageUrl}
        exclusive={getExclusiveEmblemProp(product, showExclusiveEmblem)}
        brandCd={product.brandCd}
        brandNameKr={product.brandNameKr}
        itemNameSub={product.itemNameSub}
        itemName={product.itemName}
        myHeartItem={
          product.itemCd ? !!myHeartList?.has(product.itemCd) : false
        }
        todayDeliveryTag={product.todayDeliveryTag}
        colors={product.colors}
        onClick={({ heartCnt }) =>
          onClickProduct({ ...product, heartCnt }, originalIndex)
        }
        onClickHeart={async (itemCd, isActive, heartCnt) =>
          onClickHeart?.({ ...product, heartCnt }, isActive, originalIndex)
        }
        onClickViewStylVd={() => onClickViewStylVd?.(product, originalIndex)}
      />
    </ObservedItem>
  )
);

ProductObserveGridItem.displayName = 'ProductObserveGridItem';

export default ProductObserveGridItem;
